import * as Schema from '../schema';
import assembleEntity from '../schema/assembleEntity';
import { createSelector } from 'reselect';

export const selectConductors = createSelector(
  [state => state.entities, state => state.maps.conductors, (state, id) => id],
  (entities, conductors, id) => {
    if (conductors[id]) {
      return assembleEntity(Schema.PersonList, entities, conductors[id].entities);
    }
    return [];
  }
);

export const selectConductorsIsLoading = (state, id) =>
  state.maps.conductors[id] && state.maps.conductors[id].loading;

export const selectNextConductorsCursor = (state, id) => {
  const cursor = state.maps.conductors[id] && state.maps.conductors[id].meta.cursor;
  if (cursor) {
    return cursor.next;
  }
  return null;
};

export const selectPrevConductorsCursor = (state, id) => {
  const cursor = state.maps.conductors[id] && state.maps.conductors[id].meta.cursor;
  if (cursor) {
    return cursor.prev;
  }
  return null;
};
